import { apiRequest } from '@/config/axios/axios'

export const registration = params => {
  return apiRequest.post('registration/commerceform', params)
}
